export default __webpack_public_path__ + "static/media/image-articleHero-2000x3000-png.3d226b40.png";